// +----------------------------------------------------------------------
// | 路由文件
// +----------------------------------------------------------------------
// | Copyright (c) 2018 安徽秒速科技有限公司 All rights reserved.
// +----------------------------------------------------------------------
// | Author：tangfei <957987132@qq.com>
// +----------------------------------------------------------------------

const routers = [
    {
        path: "/policy",
        name: "policy",
        meta: {
            title: "隐私政策"
        },
        component: resolve => require(["@/views/policy/index"], resolve)
    },
  {
    path: "/login",
    name: "login",
    meta: {
      title: "欢迎登录"
    },
    component: resolve => require(["@/views/login/index"], resolve)
  },
  {
    path: "/regist",
    name: "regist",
    meta: {
      title: "欢迎注册"
    },
    component: resolve => require(["@/views/regist/index"], resolve)
  },
  {
    path: "/bindphone",
    name: "bindphone",
    meta: {
      title: "绑定手机"
    },
    component: resolve => require(["@/views/bindphone/index"], resolve)
  },
  {
    path: "/forgetpassword",
    name: "forgetpassword",
    meta: {
      title: "忘记密码"
    },
    component: resolve => require(["@/views/forgetpassword/index"], resolve)
  },

    {
        path: "/daping",
        name: "daping",
        meta: {
            title: "大屏模式"
        },
        component: resolve => require(["@/views/daping/index"], resolve)
    },
    {
        path: "/shuping",
        name: "shuping",
        meta: {
            title: "生态屏"
        },
        component: resolve => require(["@/views/shuping/index"], resolve)
    },
    {
        path: "/appcontent",
        name: "appcontent",
        meta: {
            title: "app内容显示"
        },
        component: resolve => require(["@/views/shuping/appcontent"], resolve)
    },
  {
    path: "/",
    name: "main",
    meta: {
      title: "首页"
    },
    component: resolve => require(["@/views/layout/layout"], resolve),
    children: [
      {
        // 控制台
        path: "/index",
        name: "index",
        meta: {
          title: "控制台"
        },
        redirect: '/znsb'
      },

        //2019-06-27 zby
        {
            // 智能场景
            path: "/zncj",
            name: "zncj",
            meta: {
                title: " 智能场景"
            },
            component: resolve => require(["@/views/zncj/index"], resolve)
        },

        {
            // 数据统计
            path: "/sjtj",
            name: "sjtj",
            meta: {
                title: "数据统计"
            },
            component: resolve => require(["@/views/sjtj"], resolve)
        },
      {
        // 设备列表
        path: "/znsb",
        name: "znsb",
        meta: {
          title: "设备列表"
        },
        component: resolve => require(["@/views/znsb/index"], resolve)
      },
      {
        // 消息中心
        path: "/message",
        name: "message",
        meta: {
          title: "消息中心"
        },
        component: resolve => require(["@/views/message/index"], resolve)
      },
      {
        // 设备保修
        path: "/sbbx",
        name: "sbbx",
        meta: {
          title: "设备报修"
        },
        component: resolve => require(["@/views/sbbx/index"], resolve)
      },
        {
            // 养护管理
            path: "/maintain",
            name: "maintain",
            meta: {
                title: "养护管理"
            },
            component: resolve => require(["@/views/maintain/index"], resolve)
        },
        {
            // 用户手册
            path: "/manual",
            name: "manual",
            meta: {
                title: "用户手册"
            },
            component: resolve => require(["@/views/manual/index"], resolve)
        },
      {
        // 常见问题
        path: "/question",
        name: "question",
        meta: {
          title: "常见问题"
        },
        component: resolve => require(["@/views/question/index"], resolve)
      },
      {
        // 意见反馈
        path: "/proposal",
        name: "proposal",
        meta: {
          title: "意见反馈"
        },
        component: resolve => require(["@/views/proposal/index"], resolve)
      },
      {
        // 设置
        path: "/set",
        name: "set",
        meta: {
          title: "设置"
        },
        component: resolve => require(["@/views/set/index"], resolve)
      },
      {
        // 关于瀚土智能
        path: "/about",
        name: "about",
        meta: {
          title: "关于瀚土智能"
        },
        component: resolve => require(["@/views/about/index"], resolve)
      },
    ]
  },

  // +-------------------------------------
  // | 重定向
  // +-------------------------------------
  {
    path: "*",
    redirect: "/"
  }
];
export default routers;
